/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=30e53370"
const script = {}

import "./App.vue?vue&type=style&index=0&id=30e53370&lang=less"

import exportComponent from "F:\\网站\\前台\\website_font_vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__